import { transportConstants } from "utils/constants/transport-constants";
import React from "react";
import Icon from 'components/atoms/Icon'
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'

const ObjectTransport = {

	getIcon: ( kind, props = {} ) => {
		switch( kind ) {
			case transportConstants.CAR:
				return <Icon icon={ IconTimeslotConstants.CAR } { ...props } />;
				
			case transportConstants.CAR_ELECTRIC:
				return <Icon icon={ IconTimeslotConstants.CAR_ELECTRIC } { ...props } />;
				
			case transportConstants.PUBLIC_TRANSPORT:
				return <Icon icon={ IconTimeslotConstants.TRAIN } { ...props } />;
				
			case transportConstants.MOTORCYCLE:
				return <Icon icon={ IconTimeslotConstants.MOTORCYCLE } { ...props } />;
				
			case transportConstants.MOTORCYCLE_ELECTRIC:
				return <Icon icon={ IconTimeslotConstants.MOTORCYCLE_ELECTRIC } { ...props } />;
				
			case transportConstants.BIKE:
				return <Icon icon={ IconTimeslotConstants.BICYCLE } { ...props } />;
				
			case transportConstants.SCOOTER:
				return <Icon icon={ IconTimeslotConstants.SCOOTER } { ...props } />;
				
			default:
				return <Icon icon={ IconTimeslotConstants.WALKING } { ...props } />;
		}
	}
}

export default ObjectTransport
